import React, { useState, useEffect, useCallback } from "react";

import Mark from "../../../../assets/mark.svg";

import Arrowright from "../../../../assets/Arrowright.svg";
import "./VerificationDetails.css";
import check from "../../../../assets/check.svg";
import { $api } from "../../../../../../../helpers/$api";

const VerificationDetails = ({ setSection }) => {
  const [isVerified, setIsVerified] = useState(true);
  const [verificationStatus, setVerificationStatus] = useState("verified");

  let displayText;
  let displayIcon;

  switch (verificationStatus) {
    case "error": {

      displayText = "Unverified";
      displayIcon = Arrowright;
      break;
      } // TODO: change to error icon
    case "pending": {
      displayText = "Pending";
      displayIcon = check; // TODO: change to pending icon
      break;
    }
    default:
      displayText = "Verified";
      displayIcon = check;
  }

  const getKYCStatus = useCallback(async () => {
    try {
      const data = await $api.user.verifyKYCStatus();

      setIsVerified(data.status === "verified");
      setVerificationStatus(data.status);
    } catch (error) {
      // error getting kyc status
    }
  }, [setIsVerified]);

  useEffect(() => {
    getKYCStatus();
  }, [getKYCStatus]);

  return (
    <div className="verification">
      <h1>Verification</h1>
      <p className="verified-text">Verified information</p>
      <div
        className="verificationSection"
        onClick={() => {
          if (!isVerified) {
            setSection(1);
          }
        }}
        style={{
          marginTop: "30px",
        }}
      >
        <div className="verificationDetails">
          <div>
            <img src={Mark} alt="" />
          </div>
          <div>
            <p className="Details-text">Bank Details</p>
            {/* <p className="details-paragraph">Unverified</p> */}
            <p className="details-paragraph">{displayText}</p>
          </div>
        </div>
        <div>
          {/* <img src={Arrowright} alt="" className="arrow-right" /> */}
          <img src={displayIcon} alt="" className="check-icon" />
        </div>
      </div>
      <div
        className="verificationSection "
        onClick={() => {
          if (!isVerified) {
            setSection(2);
          }
        }}
      >
        <div className="verificationDetails">
          <div>
            <img src={Mark} alt="" />
          </div>
          <div>
            <p className="Details-text">Means of Identification</p>
            {/* <p className="details-paragraph">Unverified</p> */}
            <p className="details-paragraph">{displayText}</p>
          </div>
        </div>
        <div>
          {/* <img src={Arrowright} alt="" className="arrow-right" /> */}
          <img src={displayIcon} alt="" className="check-icon" />
        </div>
      </div>
      <div
        className="verificationSection"
        onClick={() => {
          if (!isVerified) {
            setSection(3);
          }
        }}
      >
        <div className="verificationDetails">
          <div>
            <img src={Mark} alt="" />
          </div>
          <div>
            <p className="Details-text">Proof of Residence</p>
            {/* <p className="details-paragraph">Unverified</p> */}
            <p className="details-paragraph">{displayText}</p>
          </div>
        </div>
        <div>
          <img src={displayIcon} alt="" className="check-icon" />
          {/* <img src={Arrowright} alt="" className="arrow-right" /> */}
        </div>
      </div>
      <div className="verificationSection">
        <div className="verificationDetails">
          <div>
            <img src={Mark} alt="arrow" />
          </div>
          <div>
            <p className="Details-text">Email Address</p>
            {/* <p className="details-paragraph">Unverified</p> */}
            <p className="details-paragraph">verified</p>
          </div>
        </div>
        <div>
          {" "}
          {/* <img src={Arrowright} alt="arrow" className="arrow-right" /> */}
          <img src={check} alt="" className="check-icon" />
        </div>
      </div>
    </div>
  );
};

export default VerificationDetails;
